import { render, staticRenderFns } from "./Bancos.vue?vue&type=template&id=687fa2e8&scoped=true&"
import script from "./Bancos.vue?vue&type=script&lang=js&"
export * from "./Bancos.vue?vue&type=script&lang=js&"
import style0 from "./Bancos.vue?vue&type=style&index=0&id=687fa2e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "687fa2e8",
  null
  
)

export default component.exports